import {createStore, applyMiddleware, Store, GenericStoreEnhancer} from "redux";
import createSagaMiddleware from 'redux-saga';

import rootReducer from "../reducer/app_reducer";
import {AppState} from "./app_state";
import rootHandler from "../handler/app_handler";

import history from '../history';
import {routerMiddleware} from 'connected-react-router';

import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";

const middlewares = [];

const sagaMiddleware = createSagaMiddleware();
middlewares.push(routerMiddleware(history));
middlewares.push(sagaMiddleware);

const middleware: GenericStoreEnhancer = composeWithDevTools(applyMiddleware(...middlewares));

const createStoreWithMiddleware = middleware<AppState>(createStore);

const createAppStore = (): Store<AppState> => {
    const store: Store<AppState> = createStoreWithMiddleware(rootReducer);
    sagaMiddleware.run(rootHandler);
    return store;
};

export default createAppStore;



// WEBPACK FOOTER //
// ./src/presentation/store/app_store.ts